import React, { useState } from "react";
import axios from "../../../../utils/cmsAxios";
import { useNavigate } from "react-router-dom";
import ConfirmModal from "../../CommonComponents/ConfirmModal";

const AdminCreate = () => {
  const navigate = useNavigate();

  const [isActive, setIsActive] = useState(true);     // 사용 여부
  const [role, setRole] = useState("STAFF");          // SUPER | MANAGER | STAFF
  const [name, setName] = useState("");
  const [adminId, setAdminId] = useState("");       // 관리자 ID(로그인)
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [department, setDepartment] = useState("");
  const [position, setPosition] = useState("");

  const [loading, setLoading] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [error, setError] = useState("");

  const canSubmit =
    adminId.trim() &&
    password.length >= 8 &&
    password === password2;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!canSubmit) {
      setError("필수 항목을 확인해주세요. (ID/비밀번호 8자 이상/일치)");
      return;
    }
    setLoading(true);
    setError("");

    const payload = {
      is_active : isActive ? 1 : 0,
      role,
      name: name.trim() || null,
      admin_id : adminId.trim() || null,
      phone : phone,
      temp_password : password,
      email : email,
      department : department.trim() || null,
      position : position.trim() || null
    }

    console.log(payload)

    try {
      await axios.post(`${process.env.REACT_APP_FASTAPI_ADS_URL}/admin/list/create`, 
        payload
      );
      setAlertMsg("등록이 완료되었습니다.");
      setOpenAlert(true);
    } catch (e) {
      console.error(e);
      setError("등록에 실패했습니다.");
    } finally {
      setLoading(false);
    }
  };

  const goList = () => navigate("/admin/list", { replace: true });

  return (
    <div className="min-h-screen bg-neutral-50">
      <div className="mx-auto max-w-[1280px] bg-white rounded-2xl shadow overflow-hidden">
        <div className="flex">
          <div className="flex-1 min-w-0 p-4 bg-neutral-50/70">
            <main className="pt-12 flex flex-col p-4 overflow-x-hidden w-full">
              <section className="p-4">
                <div className="mb-3 flex items-center justify-between">
                  <h2 className="text-xl font-semibold mb-4">관리자 계정 권한 관리 &gt; 등록</h2>
                </div>

                {error && (
                  <div className="mb-3 rounded-lg bg-red-50 text-red-700 px-3 py-2 text-sm">{error}</div>
                )}

                <div className="px-4 py-2 border-b text-sm text-neutral-500">기본 정보</div>
                <form onSubmit={handleSubmit} className="space-y-4 max-w-full">
                  {/* 기본 정보 카드 */}
                  <div className="rounded-lg border bg-white">
                    
                    <div className="p-4">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-3 text-sm">
                        {/* 사용여부 */}
                        <div className="flex items-center gap-3">
                          <div className="w-28 shrink-0 text-neutral-500">사용 여부</div>
                          <div className="flex items-center gap-6">
                            <label className="inline-flex items-center gap-2">
                              <input type="radio" name="active" checked={isActive} onChange={() => setIsActive(true)} />
                              <span>Yes</span>
                            </label>
                            <label className="inline-flex items-center gap-2">
                              <input type="radio" name="active" checked={!isActive} onChange={() => setIsActive(false)} />
                              <span>No</span>
                            </label>
                          </div>
                        </div>

                        {/* 관리자 유형 */}
                        <div className="flex items-center gap-3">
                          <div className="w-28 shrink-0 text-neutral-500">관리자 유형</div>
                          <select
                            value={role}
                            onChange={(e) => setRole(e.target.value)}
                            className="h-9 w-full rounded-md border border-neutral-300 bg-white px-2 text-sm"
                          >
                            <option value="SUPER">최고 관리자</option>
                            <option value="MANAGER">중간 관리자</option>
                            <option value="STAFF">일반 관리자</option>
                          </select>
                        </div>

                        {/* 왼쪽 열 */}
                        <L label="이름"><I value={name} onChange={e=>setName(e.target.value)} /></L>
                        <L label="관리자 ID"><I value={adminId} onChange={e=>setAdminId(e.target.value)} /></L>

                        <L label="휴대폰 번호"><I value={phone} onChange={e=>setPhone(e.target.value)} /></L>
                        <L label="비밀번호"><I type="password" value={password} onChange={e=>setPassword(e.target.value)} /></L>

                        <L label="이메일"><I value={email} onChange={e=>setEmail(e.target.value)} /></L>
                        <L label="비밀번호 확인"><I type="password" value={password2} onChange={e=>setPassword2(e.target.value)} /></L>

                        <L label="부서/팀"><I value={department} onChange={e=>setDepartment(e.target.value)} /></L>
                        <L label="직급"><I value={position} onChange={e=>setPosition(e.target.value)} /></L>
                      </div>
                    </div>
                  </div>

                  <div className="flex gap-2 justify-center">
                    <button
                      type="submit"
                      disabled={!canSubmit || loading}
                      className="rounded-lg bg-violet-300 text-violet-900 px-6 py-2 text-sm hover:bg-violet-500 disabled:opacity-50"
                    >
                      {loading ? "등록 중..." : "등록"}
                    </button>
                    <button type="button" onClick={goList} className="rounded-lg border px-6 py-2 text-sm hover:bg-gray-50">
                      이전
                    </button>
                  </div>
                </form>

                <ConfirmModal
                  open={openAlert}
                  title=""
                  message={alertMsg || "처리가 완료되었습니다."}
                  onClose={() => { setOpenAlert(false); goList(); }}
                  buttons={[{ label: "확인", intent: "primary", autoFocus: true, onClick: () => { setOpenAlert(false); goList(); } }]}
                />
              </section>
            </main>
          </div>
        </div>
      </div>
    </div>
  );
};

const L = ({ label, children }) => (
  <div className="flex items-center gap-3">
    <div className="w-28 shrink-0 text-neutral-500">{label}</div>
    <div className="flex-1">{children}</div>
  </div>
);
const I = (props) => <input className="w-full rounded-md border px-3 py-2" {...props} />;

export default AdminCreate;
